import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function FlightFillUp(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M22.5 15a.5.5 0 00.5-.5V12a.5.5 0 00-.359-.48l-8.145-2.395a39.07 39.07 0 00-.028-.896 34.77 34.77 0 00-.222-2.791c-.126-1.011-.32-2.058-.622-2.864-.15-.4-.34-.776-.588-1.06C12.783 1.224 12.438 1 12 1c-.438 0-.783.225-1.036.514-.248.284-.438.66-.588 1.06-.303.806-.496 1.853-.622 2.864a34.797 34.797 0 00-.222 2.791c-.016.367-.024.675-.028.896L1.36 11.52A.5.5 0 001 12v2.5a.5.5 0 00.5.5h8.059l.419 3.352-1.868 2.336a.5.5 0 00-.084.47l.5 1.5a.5.5 0 00.632.316L12 22.027l2.842.947a.5.5 0 00.632-.316l.5-1.5a.5.5 0 00-.084-.47l-1.868-2.335.42-3.353H22.5z",
    clipRule: "evenodd"
  }));
}

export default FlightFillUp;